export default __webpack_public_path__ + "static/media/list_alt_24px.5b2ab296.svg";